import { ReactNode } from 'react'
import { createWithEqualityFn as create } from 'zustand/traditional'

import { MapContext } from '@/feature/map'

export type ObservatoryPageStore = {
  map?: MapContext
  setMap: (map: ObservatoryPageStore['map']) => void

  showSearchMarker: boolean
  setShowSearchMarker: (showSearchMarker: boolean) => void

  mapMessage: string | ReactNode | undefined
  setMapMessage: (message: string | ReactNode | undefined) => void
}

export const useObservatoryPageStore = create<ObservatoryPageStore>((setState, _getState) => ({
  map: undefined,
  setMap: (map: ObservatoryPageStore['map']) => setState({ map }),

  showSearchMarker: true,
  setShowSearchMarker: (showSearchMarker: boolean) => setState({ showSearchMarker }),

  mapMessage: undefined,
  setMapMessage: (mapMessage: string | ReactNode | undefined) => setState({ mapMessage }),
}))
